<template>
  <div class="user-badge-wrap">
    <UserAvatar
      class="cursor-default"
      :member="user"
    />
    <span
      v-if="showUserName"
      v-member-hover-preview="getHoverMember"
      class="text-sm text-text-default overflow-hidden text-ellipsis whitespace-nowrap"
    >
      {{ nameToBeDislayed }}
    </span>
  </div>
</template>

<script>
import UserAvatar from '@/components/widgets/UserAvatar';
import getMemberLabel from '@/utilities/getMemberLabel';
import useCurrentRole from '@/utilities/composables/useCurrentRole';

export default {
  name: 'UserBadge',
  components: {
    UserAvatar,
  },
  props: {
    userId: {
      type: String,
      required: true,
    },
    showUserName: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup() {
    const { isGuest } = useCurrentRole();

    return { isGuest };
  },
  computed: {
    user() {
      return this.$store.getters.getMemberById(this.userId);
    },
    nameToBeDislayed() {
      if (!this.showUserName) return '';
      const label = getMemberLabel(this.user, true);
      if (this.isGuest && !label) return this.translate('hiddenMember');
      return label;
    },
    getHoverMember() {
      if (this.isGuest && !Object.keys(this.user).length) {
        return { id: this.userId };
      }
      return this.user;
    },
  },
};
</script>

<style lang="scss">
.user-badge-wrap {
  @apply flex items-center gap-1;
}
</style>
